import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AdminNewsThemeService } from "../service";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorToast } from "../../../shared/toasters/toasters";

export const CreateForm = ({ state, setState }: any) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setState((prev: any) => ({ ...prev, [name]: value }));
  };

  const switchHandler = (e: any) => {
    setState((prev: any) => ({ ...prev, [e.target.name]: e.target.checked }));
  };

  useEffect(() => {
    if (!!Number(id)) {
      AdminNewsThemeService.getSingle(+id!)
        .then((response) => {
          const { data } = response;
          setState(data);
          window.scrollTo(0, 0);
        })
        .catch((error) => ErrorToast(error));
    }
  }, [id]);

  return (
    <>
      <Card>
        <Card.Body>
          <Row>
            <Col md={6} className="mb-3">
              <label htmlFor="title" className="required-field">
                Title
              </label>
              <input
                type="text"
                name="title"
                className="form-control"
                required
                onChange={changeHandler}
                value={state?.id && state?.title}
              />
            </Col>
            <Col md={4} className="">
              <div className="form-check form-switch p-0">
                <label
                  className="d-block text-start"
                  htmlFor="flexSwitchCheckDefault"
                >
                  {t("download.pro_member")}
                </label>
                <div className="row">
                  <input
                    className="form-check-input switch-custom ms-4 mt-2"
                    type="checkbox"
                    name="isPro"
                    checked={state?.isPro}
                    onChange={switchHandler}
                    role="switch"
                    id="flexSwitchCheckDefault"
                  />
                </div>
              </div>
            </Col>
          </Row>
          <div className="col-12 my-2 d-flex justify-content-end text-align-center">
            <div>
              <button
                className="btn btn-info"
                onClick={() => navigate("/admin/news-theme")}
              >
                {t("global.cancel")}
              </button>
              <button className="btn btn-primary ms-3" type="submit">
                {state?.id
                  ? `  ${t("global.update")}`
                  : `${t("global.create")}`}
              </button>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
